module.exports = __webpack_public_path__ + "img/i-hospital-1.c2179d9c.png";